import React, { Component } from "react";
import "./ViewStep.css";
import { connect } from "react-redux";
import { getFormValues, Field, reduxForm } from "redux-form";
import { getTranslate } from "react-localize-redux";
import SelectCarCard from "../../../../components/Select-car-card/SelectCarCard";
import FaAutomobile from "react-icons/lib/fa/automobile";
import Guy from "../../../../components/Svgs/Man";
import Bank from "../../../../components/Svgs/Bank";
import PolicyRegScrollbar from "../../../../components/PolicyRegScrollbar/PolicyRegScrollbar";
import FaExternalLink from 'react-icons/lib/fa/external-link';

class ViewStep extends Component {
  constructor() {
    super();
    this.state = {
      buttonDisable: false,
    };
  }

  handleTermsAndCondPopup = () => {
    document
      .getElementById("policy-registration-scrollbar")
      .classList.toggle("policy-registration-scrollbar-display");
    document
      .getElementById("policy-create-card")
      .classList.toggle("policy-create-card-overflow");
  };

  handleMobileBtnDisable = () => {
    this.setState({
      buttonDisable: !this.state.buttonDisable,
    });
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    console.log(this.props.policyFields);
  }
  render() {
    const {
      isPaying,
      previousPage,
      onClick,
      policyFields,
      translate,
      isLoading,
      canPay,
      ecommerceList,
      selectedBank,
      handleSelectedBank,
      bankType,
    } = this.props;
    return (
      <div className="policy-registration-container">
        <div className="policy-create-card" id="policy-create-card">
          <PolicyRegScrollbar numb={4} />
          <div className="policy-create-card-padding">
            <div className="policy-view-group">
              <div className="policy-view-group-header-content">
                <FaAutomobile className="policy-view-group-header-icon" />
                <h3 className="policy-view-group-header">
                  {translate("transport")}
                </h3>
              </div>
              <div className="policy-view-group-content">
                <div className="policy-view-group-column">
                  {policyFields.vinCode && (
                    <div className="policy-view-group-item">
                      <span className="policy-view-group-item-value">
                        {policyFields.vinCode.toUpperCase()}
                      </span>
                    </div>
                  )}
                  <div className="policy-view-group-item">
                    <span className="policy-view-group-item-value">
                      {policyFields.vehicleRegistrationNumber.toUpperCase()}
                    </span>
                  </div>
                  <div className="policy-view-group-item">
                    <span className="policy-view-group-item-value">
                      {translate(policyFields.vehicleCategoryName)}
                    </span>
                  </div>
                </div>
                <div className="policy-view-group-column">
                  {policyFields.chassisNumber && (
                    <div className="policy-view-group-item">
                      <span className="policy-view-group-item-value">
                        {policyFields.chassisNumber.toUpperCase()}
                      </span>
                    </div>
                  )}
                  <div className="policy-view-group-item">
                    <span className="policy-view-group-item-value">
                      {policyFields.vehicleManufacturerName}
                    </span>
                  </div>
                  <div className="policy-view-group-item">
                    <span className="policy-view-group-item-value">
                      {policyFields.vehicleModelName}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="policy-view-group-header-content">
              <div className="policy-view-group-header-icon">
                <Guy width="20" heigth="25" />
              </div>
              <h3 className="policy-view-group-header">
                {translate("insurer")}
              </h3>
            </div>

            <div className="policy-view-group-content">
              <div className="policy-view-group-column">
                <div className="policy-view-group-item">
                  <span className="policy-view-group-item-value">
                    {policyFields.insurerTitle}
                  </span>
                </div>
                <div className="policy-view-group-item">
                  <span className="policy-view-group-item-value">
                    {policyFields.insurerIdentificationNumber}
                  </span>
                </div>
                <div className="policy-view-group-item">
                  <span className="policy-view-group-item-value">
                    {policyFields.insurerPhone}
                  </span>
                </div>
                <div className="policy-view-group-item">
                  <span className="policy-view-group-item-value">
                    {policyFields.insurerCitizenshipName}
                  </span>
                </div>
              </div>
              <div className="policy-view-group-column">
                <div className="policy-view-group-item">
                  <span className="policy-view-group-item-value">
                    {policyFields.insurerLastname}
                  </span>
                </div>
                <div className="policy-view-group-item">
                  <span className="policy-view-group-item-value">
                    {translate(policyFields.insurerType)}
                  </span>
                </div>
                <div className="policy-view-group-item">
                  <span className="policy-view-group-item-value">
                    {policyFields.insurerEmail}
                  </span>
                </div>
              </div>
            </div>

            <div className="policy-view-group-header-content">
              <div className="policy-view-group-header-icon">
                <Guy width="20" heigth="25" />
              </div>
              <h3 className="policy-view-group-header">
                {translate("driver")}
              </h3>
            </div>
            <div className="policy-view-group-content">
              <div className="policy-view-group-column">
                <div className="policy-view-group-item">
                  <span className="policy-view-group-item-value">
                    {policyFields.vehicleDriverTitle}
                  </span>
                </div>
                <div className="policy-view-group-item">
                  <span className="policy-view-group-item-value">
                    {policyFields.vehicleDriverPhoneNumber}
                  </span>
                </div>
                <div className="policy-view-group-item">
                  <span className="policy-view-group-item-value">
                    {policyFields.vehicleDriverCitizenshipName}
                  </span>
                </div>
              </div>
              <div className="policy-view-group-column">
                <div className="policy-view-group-item">
                  <span className="policy-view-group-item-value">
                    {policyFields.vehicleDriverLastname}
                  </span>
                </div>
                <div className="policy-view-group-item">
                  <span className="policy-view-group-item-value">
                    {policyFields.vehicleDriverIdentificationNumber}
                  </span>
                </div>
                <div className="policy-view-group-item">
                  <span className="policy-view-group-item-value">
                    {policyFields.vehicleDriverEmail}
                  </span>
                </div>
              </div>
            </div>
            <div className="policy-view-group">
              <div className="policy-view-group-header-content">
                <div className="policy-view-group-header-icon">
                  <Guy width="20" heigth="25" />
                </div>
                <h3 className="policy-view-group-header">
                  {translate("owner")}
                </h3>
              </div>
              <div className="policy-view-group-content">
                <div className="policy-view-group-column">
                  <div className="policy-view-group-item">
                    <span className="policy-view-group-item-value">
                      {policyFields.vehicleOwnerTitle}
                    </span>
                  </div>
                  <div className="policy-view-group-item">
                    <span className="policy-view-group-item-value">
                      {translate(policyFields.vehicleOwnerType)}
                    </span>
                  </div>
                  <div className="policy-view-group-item">
                    <span className="policy-view-group-item-value">
                      {policyFields.vehicleOwnerEmail}
                    </span>
                  </div>
                  <div className="policy-view-group-item">
                    <span className="policy-view-group-item-value">
                      {policyFields.vehicleOwnerCitizenshipName}
                    </span>
                  </div>
                </div>
                <div className="policy-view-group-column">
                  <div className="policy-view-group-item">
                    <span className="policy-view-group-item-value">
                      {policyFields.vehicleOwnerLastname}
                    </span>
                  </div>
                  <div className="policy-view-group-item">
                    <span className="policy-view-group-item-value">
                      {policyFields.vehicleOwnerIdentificationNumber}
                    </span>
                  </div>
                  <div className="policy-view-group-item">
                    <span className="policy-view-group-item-value">
                      {policyFields.vehicleOwnerPhone}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="policy-view-group custom-md-block">
              <div className="policy-view-group-header-content">
                <div className="policy-view-group-header-icon">
                  <Bank width="20" heigth="25" />
                </div>
                <h3 className="policy-view-group-header">
                  {translate("selectBank")}
                </h3>
              </div>
              <div className="policy-view-group-content">
                {ecommerceList && (
                  <form>
                    <div className="input-radio-group">
                      {ecommerceList.map((item, index) => (
                        <div className="bank-item" key={index}>
                          <div className="input-radio">
                            <label className="input-radio-label">
                              <Field
                                name="ecommerceListForm"
                                value={item.bank}
                                component="input"
                                type="radio"
                                checked={selectedBank === item.bank}
                                onChange={() => {
                                  handleSelectedBank(item.bank);
                                }}
                              />
                              <span className="input-radio-circle" />
                              <span className="input-radio-text">
                                {translate(bankType[item.bank])}
                              </span>
                            </label>
                          </div>
                          <div className="card-type">
                            <span className="card-type__label">
                              {translate("geoCard")}:
                            </span>
                            <span className="card-type__value">
                              {item.cardProcessingFee}%
                            </span>
                          </div>
                          <div className="card-type">
                            <span className="card-type__label">
                              {translate("notGeoCard")}:
                            </span>
                            <span className="card-type__value">
                              {item.foreignCardProcessingFee}%
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                    <br />
                  </form>
                )}
              </div>
            </div>
          </div>

          {!this.state.buttonDisable && (
              <div className="insurer-conditions-text-mobile"
                 onClick={this.handleTermsAndCondPopup}>
                 {translate("insuranceCondition")} <FaExternalLink />
            </div>
            )}

          <div className="step-btn-content viewStep-btns-mobile">
            <button className="back-btn" onClick={previousPage}>
              {" "}
              {translate("back")}
            </button>
            {/*<button className="next-btn" type="submit"   >{translate('pay')} <FaArrowCircleORight className="next-icon"/> </button>*/}
            <div
              className="mobile-Pay-Btn-Container"
              onClick={this.handleMobileBtnDisable}
            >
              {this.state.buttonDisable && (
                <button className="policy-pay-btn-mobile-disable">
                  {translate("pleaseWait")}...
                </button>
              )}

              {!this.state.buttonDisable && (
                <div className="mobile-Pay-Btn">
                  <button canPay={false} onClick={onClick}>
                    {translate("pay")}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        
        {/* <SelectCarCard
          canPay={true}
          isLoading={isPaying}
          onClick={onClick}
          handleSelectedBank={handleSelectedBank}
          ecommerceList={ecommerceList}
          selectedBank={selectedBank}
          bankType={bankType}
        /> */}

        <SelectCarCard isLoading={false} canPay={true} onClick={onClick} />

      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  policyFields: getFormValues("CreatePolicyForm")(state) || {},
  translate: getTranslate(state.locale),
});

ViewStep = reduxForm({
  form: "ecommerceListFormInViewStep", // a unique identifier for this form
})(ViewStep);

export default connect(mapStateToProps)(ViewStep);



// WEBPACK FOOTER //
// ./src/pages/PoliciesCreatePage/steps/ViewStep/ViewStep.js